export default __webpack_public_path__ + "static/media/1324.f509e9dc.png";